export const downloadDataQueryFn = async ({ path, s3Path, ...rest }) => {
  if (!path) {
    return { error: "Path is required" };
  }
  try {
    const response = await fetch(`/${path}`);
    if (!response.ok) {
      return { error: `Failed to fetch ${path}: ${response.status}` };
    }
    const contentType = response.headers.get("content-type") || "";
    const text = await response.text();
    if (contentType.includes("application/json")) {
      const parsedFile = JSON.parse(text);
      return { data: parsedFile };
    }
    return { data: text };
  } catch (error) {
    return { error: error.message };
  }
};

export const getUrlQueryFn = async ({ path }) => {
  if (!path) {
    return { error: "Path is required" };
  }
  // Since content is served through CloudFront on the same origin,
  // the URL is just the path itself
  const href = `${window.location.origin}/${path}`;
  return { data: { href } };
};
